
<i18n>
{
  "fr": {
    "nbVisitDuringWorks": "Nombre de Visites Pendant Travaux (VPT non conformes)",
    "nbVEVisits": "Nombre de Visites d'Entretien",
    "previousYear": "Année n-1",
    "currentYear": "Année en cours",
    "nbCCRainyProjects": "Nombre de conformités pluviales (VPT conformes)",
    "nbCCOnly" : "Nombre de contrôle de conformité"
  }
}
</i18n>
<template>
  <div class="bg-w">
    <div class="row">
      <div class="col-12 list-container paddingRemover col">
        <p
          v-if="synthesisStats.lastUpdatedDate"
          class="text-right"
        >Date de dernière mise à jour: {{ synthesisStats.lastUpdatedDate }}</p>

        <table class="table table-striped admin-list">
          <thead>
            <tr class="thead-color">
              <th scope="col" colspan="14">{{ $t('nbVisitDuringWorks') }}</th>
            </tr>
            <tr class="thead-color">
              <th></th>
              <th scope="col">Jan</th>
              <th scope="col">Fev</th>
              <th scope="col">Mars</th>
              <th scope="col">Avr</th>
              <th scope="col">Mai</th>
              <th scope="col">Juin</th>
              <th scope="col">Jui</th>
              <th scope="col">Août</th>
              <th scope="col">Sept</th>
              <th scope="col">Oct</th>
              <th scope="col">Nov</th>
              <th scope="col">Dec</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>{{ currentYear }}</th>
              <td
                v-for="(value, index) in synthesisStats.vptStats.currentYear"
                v-bind:key="index"
              >{{ value }}</td>
            </tr>
            <tr>
              <th>{{ previousYear }}</th>
              <td
                class="previousYearValues"
                v-for="(value, index) in synthesisStats.vptStats.previousYear"
                v-bind:key="index"
              >{{ value }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12 list-container col">
        <table class="table table-striped admin-list">
          <thead>
            <tr class="thead-color">
              <th scope="col" colspan="14">{{ $t('nbVEVisits') }}</th>
            </tr>
            <tr class="thead-color">
              <th></th>
              <th scope="col">Jan</th>
              <th scope="col">Fev</th>
              <th scope="col">Mars</th>
              <th scope="col">Avr</th>
              <th scope="col">Mai</th>
              <th scope="col">Juin</th>
              <th scope="col">Jui</th>
              <th scope="col">Août</th>
              <th scope="col">Sept</th>
              <th scope="col">Oct</th>
              <th scope="col">Nov</th>
              <th scope="col">Dec</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>{{ currentYear }}</th>
              <td
                v-for="(value, index) in synthesisStats.veStats.currentYear"
                v-bind:key="index"
              >{{ value }}</td>
            </tr>
            <tr>
              <th>{{ previousYear }}</th>
              <td
                class="previousYearValues"
                v-for="(value, index) in synthesisStats.veStats.previousYear"
                v-bind:key="index"
              >{{ value }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12 list-container paddingRemover col">
        <table class="table table-striped admin-list">
          <thead>
            <tr class="thead-color">
              <th scope="col" colspan="14">{{ $t('nbCCRainyProjects') }}</th>
            </tr>
            <tr class="thead-color">
              <th></th>
              <th scope="col">Jan</th>
              <th scope="col">Fev</th>
              <th scope="col">Mars</th>
              <th scope="col">Avr</th>
              <th scope="col">Mai</th>
              <th scope="col">Juin</th>
              <th scope="col">Jui</th>
              <th scope="col">Août</th>
              <th scope="col">Sept</th>
              <th scope="col">Oct</th>
              <th scope="col">Nov</th>
              <th scope="col">Dec</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>{{ currentYear }}</th>
              <td
                v-for="(value, index) in synthesisStats.ccRainyStats.currentYear"
                v-bind:key="index"
              >{{ value }}</td>
            </tr>
            <tr>
              <th>{{ previousYear }}</th>
              <td
                class="previousYearValues"
                v-for="(value, index) in synthesisStats.ccRainyStats.previousYear"
                v-bind:key="index"
              >{{ value }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12 list-container paddingRemover col">
        <table class="table table-striped admin-list">
          <thead>
            <tr class="thead-color">
              <th scope="col" colspan="14">{{ $t('nbCCOnly') }}</th>
            </tr>
            <tr class="thead-color">
              <th></th>
              <th scope="col">Jan</th>
              <th scope="col">Fev</th>
              <th scope="col">Mars</th>
              <th scope="col">Avr</th>
              <th scope="col">Mai</th>
              <th scope="col">Juin</th>
              <th scope="col">Jui</th>
              <th scope="col">Août</th>
              <th scope="col">Sept</th>
              <th scope="col">Oct</th>
              <th scope="col">Nov</th>
              <th scope="col">Dec</th>
              <th scope="col">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>{{ currentYear }}</th>
              <td
                v-for="(value, index) in synthesisStats.ccOnlyStats.currentYear"
                v-bind:key="index"
              >{{ value }}</td>
            </tr>
            <tr>
              <th>{{ previousYear }}</th>
              <td
                class="previousYearValues"
                v-for="(value, index) in synthesisStats.ccOnlyStats.previousYear"
                v-bind:key="index"
              >{{ value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<!--script>
  export default {
    components: {
    },
    data () {
      return {
        
      };
    },
    mounted () {
      
    },
    methods: {
    
    },
  };
</script-->

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'stats',

  data: () => ({
    loaderData: true,
    currentYear: null,
    previousYear: null,
  }),
  computed: {
    ...mapState({
      synthesisStats: state => state.refSynthesis.SynthesisStats,
      properties: state => state.refProperties.properties,
    }),
    ...mapGetters(['getNotif', 'getPageCount']),
  },
  created: function() {
    this.getSynthesisStats();
    this.currentYear = new Date().toISOString().slice(0, 4);
    this.previousYear = this.currentYear - 1;
  },
  methods: {
    getSynthesisStats() {
      this.$store.dispatch('fetchSynthesisStats').then(() => (this.loaderData = false));
    },
    getProperties() {
      this.$store.dispatch('fetchProperties').then(() => (this.loaderData = false));
    },
  },
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}

.row {
  width: 100%;
}

.previousYearValues {
  color: gray;
}

.admin-list > thead > tr > th {
  text-transform: none !important;
}
</style>